import { render } from "./ContactForm.vue?vue&type=template&id=3f1d72d5&scoped=true"
import script from "./ContactForm.vue?vue&type=script&lang=js"
export * from "./ContactForm.vue?vue&type=script&lang=js"

import "./ContactForm.vue?vue&type=style&index=0&id=3f1d72d5&scoped=true&lang=scss"

import exportComponent from "/Users/spineup/Downloads/Safe_Sites_Modifs/SAFE_ORTHO/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f1d72d5"]])

export default __exports__